module.exports = __webpack_public_path__ + "img/light.507c75cd.jpg";